import React from "react";
import { Box } from "@mui/material";
import { BannerStyled } from "./styles";
import FeesTable from "./FeesTable";
import MailPaymentBanner from "./MailPaymentBanner";

function PaymentTable({ isDynamic, formTemplate }) {
  const hasDynamicFees =
    isDynamic ||
    (formTemplate?.components || []).some(
      (tab) => tab.properties?.showFees === "true"
    );

  return (
    <Box>
      <BannerStyled>
        <MailPaymentBanner />
      </BannerStyled>
      <FeesTable isDynamic={hasDynamicFees} />
    </Box>
  );
}

export default PaymentTable;
